import React from 'react';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleLimitFilterBadgeProps {
  testId?: string;
  value?: string;
  className?: string;
  onClick?: () => void;
}

export const PowerOutageScheduleLimitFilterBadge: React.FC<
  PowerOutageScheduleLimitFilterBadgeProps
> = ({ testId, className, value, onClick }) => {
  return (
    <div
      data-testid={testId}
      className={`noto-medium-3 flex h-[30px] items-center justify-between rounded-[35px] bg-light-3 px-[14px] py-[8px] text-dark-10 ${className}`}
    >
      {value}
      <SVGImage
        onClick={onClick}
        className="ml-[8px] cursor-pointer"
        testId={`${testId}-icon`}
        name="close"
      />
    </div>
  );
};
